import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=33d9a60a"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoCard: require('/vercel/path0/components/ui/VideoCard.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default})
